<app-shared-loading *ngIf="loading"></app-shared-loading>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()"></app-return-methods>
<ng-container>
  <div class="contentBox">
    <div class="col-3">
      <div class="info-logo-container">
        <img [src]="deuna_logo" class="payment_method_no_interactive red" alt="Logo de deuna!"/>
      </div>
    </div>
    <div class="col-7">
      <div class="methodInfo">
        <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()"></app-return-methods>
        <app-payment-expiration class="payment-expiration" [expiration]="transaction.EXPIRATION"></app-payment-expiration>
        <app-counter-item [number]="1">
          <p innerHTML="{{ 'deuna-step-one' | translation | async }}"></p>
        </app-counter-item>
        <app-counter-item [number]="2">
          <p innerHTML="{{ 'deuna-step-two' | translation | async }}"></p>
        </app-counter-item>
        <div>
          <form [formGroup]="emailForm">
            <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('email') }">
              <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
              <input type="text"
                matInput name="email"
                placeholder="{{ 'forms-Email-Input' | translation | async }}"
                formControlName="email"
                [readonly]="isControlReadOnly('email')"/>
            </mat-form-field>
            <ng-container *ngFor="let validation of errorMessages.email">
              <div class="error-message" *ngIf="emailForm.get('email').hasError(validation.type) && (emailForm.get('email').dirty || emailForm.get('email').touched)">
                {{ validation.message }}
              </div>
            </ng-container>
          </form>
        </div>
        <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
      </div>
      <app-buttons-bar
        [valid]="completedForms()"
        [template]="template"
        nameCustom="{{ 'deposit-Send' | translation | async }}"
        (CUSTOM)="sendEmail()"
        class="buttonEnd">
    </app-buttons-bar>
    </div>
  </div>
</ng-container>

